import { FecImportLifecycleStatus } from '../enums/fecImportLifecycleStatus'
import type { FecImportItem } from '../query-api'

const ANALYSIS_FAILED_STATUSES: ReadonlySet<FecImportLifecycleStatus> = new Set([
  FecImportLifecycleStatus.DetectionFailed,
  FecImportLifecycleStatus.ParsingFailed,
])

export const isFecImportAnalysisFailed = (fecImport: Pick<FecImportItem, 'status'>): boolean =>
  ANALYSIS_FAILED_STATUSES.has(fecImport.status)
